/**
 * Segment load
 */
export const load = () => {}

/**
 * Segment pageview
 * @param name
 * @param properties
 */
export const page = (name: string, properties: any) => {
  if (window?.analytics?.page) window.analytics.page(name, properties)
}

/**
 * Segment track event
 * @param name
 * @param properties
 */
export const track = (name: string, properties: any) => {
  if (window?.analytics?.track) window.analytics.track(name, properties)
}
